<template>
    <div class="text-button" @click="actionClick">
        <span v-if="!loadingState" v-text="label"></span>
        <loader v-else/>
    </div>
</template>

<script>
    import Loader from "./Loader";

    export default {
        name: "TextButton",
        components: {Loader},
        props: {
            label: {
                type: [String, Number],
                required: true,
            },
            loadingState: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            actionClick() {
                if (!this.loadingState) {
                    this.$emit('click');
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/variables";

    .text-button {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 12px;
        height: 42px;
        border-radius: $s-border-radius;
        box-sizing: border-box;
        background-color: var(--accent-color);
        text-transform: uppercase;
        color: var(--text-color);
        font-weight: normal;
        transition: $transition;
        cursor: pointer;

        &:hover {
            background-color: var(--darken-accent-color);
        }

        &.small {
            height: 24px;
            font-size: $s-font-size;
        }
    }
</style>
